import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import styles from './_receiptPage.css'
import { connect } from 'react-redux'
import { FormattedNumber, FormattedMessage, FormattedDate, injectIntl } from 'react-intl'
import LineItem from './LineItem'
import Button from 'components/util/Button'
import { push } from 'react-router-redux'
import * as premium from 'services/premium/selectors'
import receiptImage from 'images/crown-success.png'
import sharedMessages from './messages'
import { FormattedDuration } from 'shared/units'
import { LONG } from 'shared/units/constants'
import * as site from 'services/site/selectors'
import * as user from 'services/user/selectors'

const mapStateToProps = (state) => ({
  siteName: site.selectSiteName(state),
  email: user.selectEmail(state),
  subInterval: premium.selectProductInterval(state),
  subUnit: premium.selectProductUnit(state),
  isTrial: premium.selectIsTrial(state),
  isPromo: premium.selectIsPromo(state),
  productUnit: premium.selectProductUnit(state),
  productFreeEndDate: premium.selectProductFreeEndDate(state),
  productEndDate: premium.selectProductEndDate(state),
  productAmount: premium.selectAmount(state),
  currency: premium.selectCurrency(state),
  productFreeInterval: premium.selectProductFreeInterval(state),
  productFreeUnit: premium.selectProductFreeUnit(state),
})

const mapDispatchToActions = {
  push,
}

export class ReceiptPage extends Component {

  static propTypes = {
    push: PropTypes.func,
    sitename: PropTypes.string,
    isTrial: PropTypes.bool,
    email: PropTypes.string,
    subInterval: PropTypes.number,
    subUnit: PropTypes.string,
    renewDate: PropTypes.object,
    isPromo: PropTypes.bool,
    productUnit: PropTypes.string,
    productFreeEndDate: PropTypes.object,
    productEndDate: PropTypes.object,
    productAmount: PropTypes.number,
    currency: PropTypes.string,
    productFreeInterval: PropTypes.number,
    productFreeUnit: PropTypes.string,
    intl: PropTypes.object,
  };

  componentWillMount () {
    const { productUnit } = this.props
    if (!productUnit) {
      this.props.push('/premium/membership')
    }
  }

  handleDone = () => {
    window.location.href = '/my_home/'
  };

  render () {
    const {
      sitename,
      email,
      subInterval,
      subUnit,
      isTrial,
      isPromo,
      productFreeEndDate,
      productEndDate,
      currency,
      productAmount,
      productFreeInterval,
      productFreeUnit,
      intl,
    } = this.props

    return (
      <div className={styles.container}>
        <Helmet title={intl.formatMessage({
          id: 'premium.welcome.title',
          defaultMessage: 'Welcome to MVP',
        })} />

        <div className={styles.col}>
          <img className={styles.image} src={receiptImage} />
          <div className={styles.image} />
        </div>

        <div className={styles.col}>
          <h2 className={styles.title}>
            {isTrial || isPromo ?
              <FormattedMessage
                id='premium.welcome.enjoy_trial'
                defaultMessage='Enjoy {trialDuration} of {sitename} MVP!'
                values={{
                  sitename,
                  trialDuration: (
                    <FormattedDuration
                      value={productFreeInterval}
                      from={productFreeUnit}
                      digits={0}
                      unit={LONG}
                    />
                  ),
                }}
              />
            :
              <FormattedMessage
                id='premium.welcome.headline'
                defaultMessage='Welcome to {sitename} MVP!'
                values={{ sitename }}
              />
            }
          </h2>

          <div>
            <div className={styles.lineItems}>

              {isTrial && !isPromo ?
                <LineItem>
                  <FormattedMessage
                    id='premium.welcome.free_trial'
                    defaultMessage='Free Trial:'
                  />
                  <div className={styles.trialPeriod}>
                    <FormattedMessage
                      id='premium.welcome.trial_period'
                      defaultMessage='{from} - {to}'
                      values={{
                        from: <FormattedDate value={new Date()} year='numeric' month='short' day='2-digit' />,
                        to: <FormattedDate value={productFreeEndDate} year='numeric' month='short' day='2-digit' />,
                      }}
                    />
                  </div>
                </LineItem>
              : null}

              <LineItem>
                <div>
                  <FormattedMessage
                    id='premium.welcome.your_plan'
                    defaultMessage='Your Plan:'
                  />
                </div>
                <div className={styles.total}>
                  {isPromo ?
                    <FormattedMessage
                      id='premium.checkout.plan_details_promo'
                      defaultMessage='Free {freeDuration} plan'
                      values={{
                        freeDuration: (
                          <FormattedDuration
                            value={productFreeInterval}
                            from={productFreeUnit}
                            digits={0}
                            unit={LONG}
                          />
                        ),
                      }}
                    />
                  :
                    <FormattedMessage
                      id='premium.checkout.receipt.plan_details'
                      defaultMessage='{interval} {unit}, {displayPrice}/{shortUnit}'
                      values={{
                        interval: subInterval,
                        unit: sharedMessages.durations.long[subUnit],
                        displayPrice: (
                          <FormattedNumber
                            style='currency'
                            currencyDisplay='symbol'
                            value={productAmount}
                            currency={currency}
                          />
                        ),
                        shortUnit: sharedMessages.durations.short[subUnit],
                      }}
                    />
                  }
                </div>
              </LineItem>

              {isPromo ?
                <LineItem>
                  <FormattedMessage
                    id='premium.welcome.expires'
                    defaultMessage='Expires:'
                  />
                  <div>
                    <FormattedDate
                      value={productFreeEndDate}
                      year='numeric'
                      month='long'
                      day='numeric'
                      weekday='long'
                    />
                  </div>
                </LineItem>
              : null}

              {!isPromo && productEndDate ?
                <LineItem>
                  <div>
                    <FormattedMessage
                      id='premium.welcome.renews_on'
                      defaultMessage='Renews On:'
                    />
                  </div>
                  <div className={styles.renewsOn}>
                    <FormattedDate
                      value={isTrial ? productFreeEndDate : productEndDate}
                      year='numeric'
                      month='short'
                      day='2-digit'
                    />
                  </div>
                </LineItem>
              : null}
            </div>

            {isTrial && !isPromo ?
              <div className={styles.note}>
                <FormattedMessage
                  id='premium.welcome.charged_trial_ends'
                  defaultMessage='You will not be charged until after your free trial ends on {renewDate}'
                  values={{ renewDate: <FormattedDate value={productFreeEndDate} /> }}
                />
              </div>
            : null}

            {isPromo ?
              <div className={styles.note}>
                <FormattedMessage
                  id='premium.welcome.not_charged'
                  defaultMessage={`
                    You will not be charged as we have not received any payment
                    information for this plan.
                  `}
                />
              </div>
            : null}

          </div>
          <p className={styles.text}>
            <FormattedMessage
              id='premium.welcome.email_reciept'
              defaultMessage='An email receipt will be sent to: {email}'
              values={{ email }}
            />
          </p>
          <Button
            size='large'
            type='primary'
            className={styles.doneButton}
            onClick={this.handleDone}
          >
            <FormattedMessage
              id='premium.welcome.done'
              defaultMessage='Done'
            />
          </Button>
        </div>

      </div>
    )

  }

}

export const Page = injectIntl(ReceiptPage)
export default connect(mapStateToProps, mapDispatchToActions)(Page)



// WEBPACK FOOTER //
// ./src/components/premium/ReceiptPage.jsx